import React from 'react'
import { Navebarehero } from '../Components/Navebarehero'
import { HeroSection } from '../Components/HeroSection'
import { HomeAboutUs } from '../Components/HomeAboutUs'
import { HomeDevelopers } from '../Components/HomeDevelopers'
import { HomeLatestProjects } from '../Components/HomeLatestProjects'
import { HomeBlogs } from '../Components/HomeBlogs'
import { HomeContactUs } from '../Components/HomeContactUs'

export const HomePage = () => {
  return (
    <div>
        <Navebarehero/>
        <HeroSection/>
        <HomeAboutUs/>
        <HomeDevelopers/>
        <HomeLatestProjects/>
        <HomeBlogs/>
        <HomeContactUs/>
    </div>
  )
}
